import { Feature } from "../homepage/features-section/Feature"
import "./stats.css"

export function Stats() {
    return (
        <div className="stats-wrapper py-5">
            <div className="d-flex justify-content-between text-white stats-section mx-auto md-row">
                <Feature
                    feature="sellers-active"
                    heading="10.5K"
                    description="Sellers active on our site"
                />
                <Feature
                    feature="monthly-sale"
                    heading="33K"
                    description="Monthly Product Sale"
                />
                <Feature
                    feature="customers-active"
                    heading="45.5K"
                    description="Customers active in our site"
                />
                <Feature
                    feature="annual-sale"
                    heading="25K"
                    description="Annual gross sale in out site"
                />
            </div>
        </div>
    )
}